// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1-7K2","left":"styles_left__13CAx"};